import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./auth/auth.service";
import { inject } from "@angular/core";
import { ApiService } from "./http/api.service";
import { catchError, mergeMap } from "rxjs/operators";
import { of, throwError } from "rxjs";

export const subscriptionGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const apiService: ApiService = inject(ApiService);
  const router: Router = inject(Router);

  return authService.getUser().pipe(
    mergeMap((u) => apiService.getAccount(u.attributes["custom:account"])),
    mergeMap((a) =>
      a.subscription_id
        ? apiService.getSubscription(a.subscription_id)
        : of({ status: "inactive" })
    ),
    mergeMap((s) =>
      s.status === "active" ||
      s.status === "past_due" ||
      s.status === "trialing"
        ? of(true)
        : throwError("no active subscription")
    ),
    catchError(() => router.navigate(["/subscribe"]))
  );
};
